import { create } from 'zustand';
import type { GraphicsPreset } from '@il-colpo/shared/settings';

const BOOT_KEY = 'ilcolpo.booted';

function readBooted(): boolean {
  try {
    return sessionStorage.getItem(BOOT_KEY) === '1';
  } catch {
    return false;
  }
}

interface AppState {
  /** The splash runs once per tab/session; deep links work afterwards. */
  booted: boolean;
  /** Preset picked by device detection (used when the setting is "auto"). */
  detectedPreset: GraphicsPreset;
  /** False when WebGL is unavailable: the animated backdrop is skipped. */
  webglAvailable: boolean;
  markBooted: () => void;
  setDetection: (preset: GraphicsPreset, webgl: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  booted: readBooted(),
  detectedPreset: 'medium',
  webglAvailable: true,
  markBooted: () => {
    try {
      sessionStorage.setItem(BOOT_KEY, '1');
    } catch {
      // Session storage unavailable: the splash will simply show again on reload.
    }
    set({ booted: true });
  },
  setDetection: (detectedPreset, webglAvailable) => {
    set({ detectedPreset, webglAvailable });
  },
}));
